import service from './api.services';

const listarSolicitacoesEnvioMonitoramento = async (filtro) => {
    const response = await service.get('api/solicitacao-envio-monitoramento/listar', {
        params: { ...filtro },
        hideLoading: true,
    });
    return response.data;
};

const salvarAnaliseSolicitacao = async (form) => {
    const response = await service.post('api/solicitacao-envio-monitoramento/salvar-analise', form);
    return response.data;
};
export {
    listarSolicitacoesEnvioMonitoramento,
    salvarAnaliseSolicitacao
};
